import { render, staticRenderFns } from "./wsVideo.vue?vue&type=template&id=46fde1d2&scoped=true&"
import script from "./wsVideo.vue?vue&type=script&lang=js&"
export * from "./wsVideo.vue?vue&type=script&lang=js&"
import style0 from "./wsVideo.vue?vue&type=style&index=0&id=46fde1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fde1d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VFadeTransition,VIcon,VMenu,VProgressLinear,VSheet,VSlider})
